var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1095"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1095"
    },
    "bundlingPackage": "ecosystem-marketplace-solutions-public-ui",
    "bundlingPackageVersion": "static-1.17751",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};